import { JWT } from 'constants/system';

const getJwtKey = () => sessionStorage.getItem(`SESSION_${JWT}_KEY`) || JWT;

export default getJwtKey;
